const selectDeviceAttributeValues = state => state.data.deviceAttributeValues

const DeviceAttributeValueDataStoreSelectors = {
  deviceAttributeValues: selectDeviceAttributeValues
}

export default DeviceAttributeValueDataStoreSelectors
